/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrmProjectNoteData } from './CrmProjectNoteData';
import {
    CrmProjectNoteDataFromJSON,
    CrmProjectNoteDataFromJSONTyped,
    CrmProjectNoteDataToJSON,
    CrmProjectNoteDataToJSONTyped,
} from './CrmProjectNoteData';
import type { CrmProjectIntegrationData } from './CrmProjectIntegrationData';
import {
    CrmProjectIntegrationDataFromJSON,
    CrmProjectIntegrationDataFromJSONTyped,
    CrmProjectIntegrationDataToJSON,
    CrmProjectIntegrationDataToJSONTyped,
} from './CrmProjectIntegrationData';
import type { CrmProjectContactData } from './CrmProjectContactData';
import {
    CrmProjectContactDataFromJSON,
    CrmProjectContactDataFromJSONTyped,
    CrmProjectContactDataToJSON,
    CrmProjectContactDataToJSONTyped,
} from './CrmProjectContactData';
import type { CrmPrimaryContactData } from './CrmPrimaryContactData';
import {
    CrmPrimaryContactDataFromJSON,
    CrmPrimaryContactDataFromJSONTyped,
    CrmPrimaryContactDataToJSON,
    CrmPrimaryContactDataToJSONTyped,
} from './CrmPrimaryContactData';
import type { CrmProjectSubscriptionData } from './CrmProjectSubscriptionData';
import {
    CrmProjectSubscriptionDataFromJSON,
    CrmProjectSubscriptionDataFromJSONTyped,
    CrmProjectSubscriptionDataToJSON,
    CrmProjectSubscriptionDataToJSONTyped,
} from './CrmProjectSubscriptionData';
import type { CrmProjectBillingData } from './CrmProjectBillingData';
import {
    CrmProjectBillingDataFromJSON,
    CrmProjectBillingDataFromJSONTyped,
    CrmProjectBillingDataToJSON,
    CrmProjectBillingDataToJSONTyped,
} from './CrmProjectBillingData';
import type { CrmProjectDomainData } from './CrmProjectDomainData';
import {
    CrmProjectDomainDataFromJSON,
    CrmProjectDomainDataFromJSONTyped,
    CrmProjectDomainDataToJSON,
    CrmProjectDomainDataToJSONTyped,
} from './CrmProjectDomainData';

/**
 * 
 * @export
 * @interface CrmListRowData
 */
export interface CrmListRowData {
    /**
     * 
     * @type {string}
     * @memberof CrmListRowData
     */
    crmId?: string;
    /**
     * 
     * @type {CrmListRowDataRecordTypeEnum}
     * @memberof CrmListRowData
     */
    recordType?: CrmListRowDataRecordTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CrmListRowData
     */
    projectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmListRowData
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmListRowData
     */
    currency?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmListRowData
     */
    projectCreatedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmListRowData
     */
    capturedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CrmListRowData
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CrmListRowData
     */
    deletedAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmListRowData
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CrmListRowData
     */
    archivedAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmListRowData
     */
    isArchived?: boolean;
    /**
     * 
     * @type {CrmListRowDataLifecycleEnum}
     * @memberof CrmListRowData
     */
    lifecycle?: CrmListRowDataLifecycleEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CrmListRowData
     */
    primaryContactUserId?: string | null;
    /**
     * 
     * @type {CrmListRowDataPrimaryContactOriginEnum}
     * @memberof CrmListRowData
     */
    primaryContactOrigin?: CrmListRowDataPrimaryContactOriginEnum;
    /**
     * 
     * @type {CrmPrimaryContactData}
     * @memberof CrmListRowData
     */
    primaryContact?: CrmPrimaryContactData | null;
    /**
     * 
     * @type {CrmListRowDataCrmStatusEnum}
     * @memberof CrmListRowData
     */
    crmStatus?: CrmListRowDataCrmStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof CrmListRowData
     */
    nextContactAt?: Date | null;
    /**
     * 
     * @type {CrmProjectNoteData}
     * @memberof CrmListRowData
     */
    latestNote?: CrmProjectNoteData | null;
    /**
     * 
     * @type {CrmProjectBillingData}
     * @memberof CrmListRowData
     */
    billing?: CrmProjectBillingData | null;
    /**
     * 
     * @type {Array<CrmProjectContactData>}
     * @memberof CrmListRowData
     */
    contacts?: Array<CrmProjectContactData>;
    /**
     * 
     * @type {Array<CrmProjectIntegrationData>}
     * @memberof CrmListRowData
     */
    integrations?: Array<CrmProjectIntegrationData>;
    /**
     * 
     * @type {CrmProjectSubscriptionData}
     * @memberof CrmListRowData
     */
    subscription?: CrmProjectSubscriptionData | null;
    /**
     * 
     * @type {CrmListRowDataSubscriptionKnowledgeEnum}
     * @memberof CrmListRowData
     */
    subscriptionKnowledge?: CrmListRowDataSubscriptionKnowledgeEnum;
    /**
     * 
     * @type {number}
     * @memberof CrmListRowData
     */
    noteCount?: number;
    /**
     * 
     * @type {Array<CrmProjectDomainData>}
     * @memberof CrmListRowData
     */
    domains?: Array<CrmProjectDomainData>;
    /**
     * 
     * @type {CrmListRowDataDomainsKnowledgeEnum}
     * @memberof CrmListRowData
     */
    domainsKnowledge?: CrmListRowDataDomainsKnowledgeEnum;
}


/**
 * @export
 */
export const CrmListRowDataRecordTypeEnum = {
    Project: 'project',
    Opportunity: 'opportunity'
} as const;
export type CrmListRowDataRecordTypeEnum = typeof CrmListRowDataRecordTypeEnum[keyof typeof CrmListRowDataRecordTypeEnum];

/**
 * @export
 */
export const CrmListRowDataLifecycleEnum = {
    Active: 'active',
    Deleted: 'deleted'
} as const;
export type CrmListRowDataLifecycleEnum = typeof CrmListRowDataLifecycleEnum[keyof typeof CrmListRowDataLifecycleEnum];

/**
 * @export
 */
export const CrmListRowDataPrimaryContactOriginEnum = {
    Observed: 'observed',
    LegacyInferred: 'legacy_inferred',
    Manual: 'manual',
    Unknown: 'unknown'
} as const;
export type CrmListRowDataPrimaryContactOriginEnum = typeof CrmListRowDataPrimaryContactOriginEnum[keyof typeof CrmListRowDataPrimaryContactOriginEnum];

/**
 * @export
 */
export const CrmListRowDataCrmStatusEnum = {
    New: 'new',
    Contacted: 'contacted',
    NeedsHelp: 'needs_help',
    Waiting: 'waiting',
    Active: 'active',
    Churned: 'churned',
    Closed: 'closed'
} as const;
export type CrmListRowDataCrmStatusEnum = typeof CrmListRowDataCrmStatusEnum[keyof typeof CrmListRowDataCrmStatusEnum];

/**
 * @export
 */
export const CrmListRowDataSubscriptionKnowledgeEnum = {
    Known: 'known',
    Unknown: 'unknown',
    NotApplicable: 'not_applicable'
} as const;
export type CrmListRowDataSubscriptionKnowledgeEnum = typeof CrmListRowDataSubscriptionKnowledgeEnum[keyof typeof CrmListRowDataSubscriptionKnowledgeEnum];

/**
 * @export
 */
export const CrmListRowDataDomainsKnowledgeEnum = {
    Known: 'known',
    Unknown: 'unknown',
    NotApplicable: 'not_applicable'
} as const;
export type CrmListRowDataDomainsKnowledgeEnum = typeof CrmListRowDataDomainsKnowledgeEnum[keyof typeof CrmListRowDataDomainsKnowledgeEnum];


/**
 * Check if a given object implements the CrmListRowData interface.
 */
export function instanceOfCrmListRowData(value: object): value is CrmListRowData {
    return true;
}

export function CrmListRowDataFromJSON(json: any): CrmListRowData {
    return CrmListRowDataFromJSONTyped(json, false);
}

export function CrmListRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmListRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'crmId': json['crmId'] == null ? undefined : json['crmId'],
        'recordType': json['recordType'] == null ? undefined : json['recordType'],
        'projectId': json['projectId'] === undefined ? undefined : json['projectId'] === null ? null : json['projectId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'currency': json['currency'] === undefined ? undefined : json['currency'] === null ? null : json['currency'],
        'projectCreatedAt': json['projectCreatedAt'] === undefined ? undefined : json['projectCreatedAt'] === null ? null : (new Date(json['projectCreatedAt'])),
        'capturedAt': json['capturedAt'] == null ? undefined : (new Date(json['capturedAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'deletedAt': json['deletedAt'] === undefined ? undefined : json['deletedAt'] === null ? null : (new Date(json['deletedAt'])),
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'archivedAt': json['archivedAt'] === undefined ? undefined : json['archivedAt'] === null ? null : (new Date(json['archivedAt'])),
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'lifecycle': json['lifecycle'] === undefined ? undefined : json['lifecycle'] === null ? null : json['lifecycle'],
        'primaryContactUserId': json['primaryContactUserId'] === undefined ? undefined : json['primaryContactUserId'] === null ? null : json['primaryContactUserId'],
        'primaryContactOrigin': json['primaryContactOrigin'] == null ? undefined : json['primaryContactOrigin'],
        'primaryContact': json['primaryContact'] === undefined ? undefined : json['primaryContact'] === null ? null : CrmPrimaryContactDataFromJSON(json['primaryContact']),
        'crmStatus': json['crmStatus'] == null ? undefined : json['crmStatus'],
        'nextContactAt': json['nextContactAt'] === undefined ? undefined : json['nextContactAt'] === null ? null : (new Date(json['nextContactAt'])),
        'latestNote': json['latestNote'] === undefined ? undefined : json['latestNote'] === null ? null : CrmProjectNoteDataFromJSON(json['latestNote']),
        'billing': json['billing'] === undefined ? undefined : json['billing'] === null ? null : CrmProjectBillingDataFromJSON(json['billing']),
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(CrmProjectContactDataFromJSON)),
        'integrations': json['integrations'] == null ? undefined : ((json['integrations'] as Array<any>).map(CrmProjectIntegrationDataFromJSON)),
        'subscription': json['subscription'] === undefined ? undefined : json['subscription'] === null ? null : CrmProjectSubscriptionDataFromJSON(json['subscription']),
        'subscriptionKnowledge': json['subscriptionKnowledge'] == null ? undefined : json['subscriptionKnowledge'],
        'noteCount': json['noteCount'] == null ? undefined : json['noteCount'],
        'domains': json['domains'] == null ? undefined : ((json['domains'] as Array<any>).map(CrmProjectDomainDataFromJSON)),
        'domainsKnowledge': json['domainsKnowledge'] == null ? undefined : json['domainsKnowledge'],
    };
}

export function CrmListRowDataToJSON(json: any): CrmListRowData {
    return CrmListRowDataToJSONTyped(json, false);
}

export function CrmListRowDataToJSONTyped(value?: CrmListRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'crmId': value['crmId'],
        'recordType': value['recordType'],
        'projectId': value['projectId'],
        'name': value['name'],
        'currency': value['currency'],
        'projectCreatedAt': value['projectCreatedAt'] == null ? value['projectCreatedAt'] : value['projectCreatedAt'].toISOString(),
        'capturedAt': value['capturedAt'] == null ? value['capturedAt'] : value['capturedAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'deletedAt': value['deletedAt'] == null ? value['deletedAt'] : value['deletedAt'].toISOString(),
        'isDeleted': value['isDeleted'],
        'archivedAt': value['archivedAt'] == null ? value['archivedAt'] : value['archivedAt'].toISOString(),
        'isArchived': value['isArchived'],
        'lifecycle': value['lifecycle'],
        'primaryContactUserId': value['primaryContactUserId'],
        'primaryContactOrigin': value['primaryContactOrigin'],
        'primaryContact': CrmPrimaryContactDataToJSON(value['primaryContact']),
        'crmStatus': value['crmStatus'],
        'nextContactAt': value['nextContactAt'] == null ? value['nextContactAt'] : value['nextContactAt'].toISOString(),
        'latestNote': CrmProjectNoteDataToJSON(value['latestNote']),
        'billing': CrmProjectBillingDataToJSON(value['billing']),
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(CrmProjectContactDataToJSON)),
        'integrations': value['integrations'] == null ? undefined : ((value['integrations'] as Array<any>).map(CrmProjectIntegrationDataToJSON)),
        'subscription': CrmProjectSubscriptionDataToJSON(value['subscription']),
        'subscriptionKnowledge': value['subscriptionKnowledge'],
        'noteCount': value['noteCount'],
        'domains': value['domains'] == null ? undefined : ((value['domains'] as Array<any>).map(CrmProjectDomainDataToJSON)),
        'domainsKnowledge': value['domainsKnowledge'],
    };
}

